import { Component, OnInit } from '@angular/core';
import {Audit} from "../../../../models/audit.model";
import {AuditService} from "../../../../services/audit.service";
import {FormBuilder, Validators} from "@angular/forms";
import * as moment from "moment";
import {EntityService} from "../../../../services/entity.service";
import {Entity} from "../../../../models/entity.model";
import Swal from "sweetalert2";

@Component({
  selector: 'app-audit',
  templateUrl: './audit.component.html',
  styleUrls: ['./audit.component.scss']
})
export class AuditComponent implements OnInit {

  pageNumber: number = 1;
  pageSize: number = 20;
  totalItems: number;

  audits: Audit[] = [];
  entities: Entity[] = [];
  actions: string[] = [];
  currentAudit: Audit;

  startDate: string = '';
  endDate: string = '';
  actor: string = '';
  objectId: string = '';
  objectType: string = '';
  action: string;

  sorted1: any;
  sorted2: any;

  searchForm = this.fb.group({
    startDate: [''],
    endDate: [''],
    actor: [''],
    objectId: [''],
    objectType: [''],
    action: [''],
  })

  constructor(private auditService: AuditService,
              private fb: FormBuilder,
              private entityService: EntityService) {
    this.actions = [
      'CONNEXION',
      'MODIFICATION',
      'DELETION',
      'CREATION'
    ]
  }

  ngOnInit(): void {
    this.allEntities();
  }

  allEntities(){
    this.entityService.getEntity().subscribe(data => {
      this.entities = data;
    })
  }

  getEndDate(event){
    this.endDateInput=event.target.value;
    //console.log(this.endDateInput);
    //console.log(this.beginDateInput)
    if(this.beginDateInput > this.endDateInput){
      this.displayError = true;
    }else {
      this.displayError = false;
    }
  }

  //isSearchClicked = false;
  readonly = true;

  disableEndDate: boolean = true;
  beginDateInput: string = null;
  endDateInput: string = null;
  displayError: boolean = false;
  getStartDate(e) {
    this.beginDateInput = e.target.value;
    if(this.beginDateInput){
      this.disableEndDate = false;
    }
  }

  unDisplaySearchError = false;
  search() {
    this.changerValeurAvecDelai().then(() => {
      // console.log('La valeur a été changée avec succès.');
      // console.log('Nouvelle valeur de test:', this.unDisplaySearchError);
      }).catch((error) => {
      // console.error('Une erreur s\'est produite:', error);
    });
    // this.unDisplaySearchError = true;
    this.actor = this.searchForm.get(['actor']).value;
    this.startDate = this.searchForm.get(['startDate']).value;
    this.endDate = this.searchForm.get(['endDate']).value;
    this.objectId = this.searchForm.get(['objectId']).value;
    this.objectType = this.searchForm.get(['objectType']).value;
    this.action = this.searchForm.get(['action']).value;

    if(this.startDate != null || this.startDate != undefined){
      this.startDate = moment(this.startDate).format('yyyy-MM-DD');
    }
    if(this.endDate != null || this.endDate != undefined){
      this.endDate = moment(this.endDate).format('yyyy-MM-DD');
    }

    if(this.startDate > this.endDate){
      Swal.fire({
        position: 'top-end',
        icon: 'warning',
        title: "Oup! La date de début est supérieur à la date de fin",
        showConfirmButton: false,
        timer: 2500
      });
      return;
    }

    this.auditService.auditsFilter(this.pageNumber - 1, this.pageSize, this.startDate, this.endDate, this.actor, this.action, this.objectId, this.objectType).subscribe(data =>{
      this.audits = data.content;
      this.totalItems = data.totalElements;
    }, error => {
     // console.log(error)
    });
  }

  changerValeurAvecDelai(): Promise<void> {
    return new Promise<void>((resolve) => {
      setTimeout(() => {
        this.unDisplaySearchError = true;
        resolve();
      }, 10000);
    });
  }

  clearSearch(){
    this.searchForm.patchValue({
      startDate: [''],
      endDate: [''],
      actor: [''],
      objectId: [''],
      objectType: [''],
      action: [''],
    });
    this.audits = [];
    this.disableEndDate = true;
    this.displayError = false;
    this.unDisplaySearchError = false;
    this.pageNumber = 1;
  }

  /*clearSearch(){
    this.searchForm.reset();
    this.audits = [];
  }*/

  sortObject() {
    if (this.sorted1 == false) {
      // @ts-ignore
      this.audits.sort((a, b) => a.objectType > b.objectType ? 1 : a.objectType < b.objectType ? -1 : 0);
      this.sorted1 = true;
    } else {
      // @ts-ignore
      this.audits.sort((a, b) => a.objectType < b.objectType ? 1 : a.objectType > b.objectType ? -1 : 0);
      this.sorted1 = false;
    }
  }

  sortDate() {
    if (this.sorted1 == false) {
      // @ts-ignore
      this.audits.sort((a, b) => a.date > b.date ? 1 : a.date < b.date ? -1 : 0);
      this.sorted2 = true;
    } else {
      // @ts-ignore
      this.audits.sort((a, b) => a.date < b.date ? 1 : a.date > b.date ? -1 : 0);
      this.sorted2 = false;
    }
  }

  viewDetails(auditId: number) {
    this.auditService.getidAudit(auditId).subscribe(data => {
      this.currentAudit = data;
      this.displayPrices();
    }, error => {
      //console.log(error);
    })
  }

  auditTemp: any[] = [];

  displayPrices(){
    this.auditTemp = [];
    this.audits.forEach(el => {
      if(el.objectId == this.currentAudit?.objectId && el.messageMap && el.messageMap.price){
        this.auditTemp.push(el);
      }
    });
   // console.log(this.auditTemp);
  }
}
